import React from 'react';
import Navbar from './Navbar';
import Icon from '../assets/Icon1.png';
import Team from './Team';

const AboutContent = () => {
  return (
    <div className=''>
        <div className='px-20 py-4 bg-[#8AD7BD]/60 flex flex-col'>
            <div className='flex '>
                <div className='basis-[60%]'>
                    <Navbar />
                    <div className='pl-4 mt-24 mb-32 flex flex-col gap-4'>
                        <span className='text-7xl font-medium tracking-wide leading-tight opacity-90'>We Are Vyda</span>
                        <span className='text-lg font-normal tracking-wider opacity-80'>Where your brand's full potential becomes its reality. Let's embark on this journey of growth together.Let's embark on this journey of growth together.</span>
                    </div>
                </div>
            </div>
            <div className='flex gap-8 justify-center items-center -mt-12'>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-semibold text-lg'>8 Years of experience</span>
                    <span className='opacity-80 font-semibold text-base w-80'>Make your business identity as unique as possible</span>
                </div>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-semibold text-lg'>20+ Clients</span>
                    <span className='opacity-80 font-semibold text-base w-80'>Make your business identity as unique as possible</span>
                </div>
                <div className='flex px-4 py-8 flex-col gap-3 bg-white'>
                    <span className='w-12 h-12'><img src={Icon} alt='' className='w-full h-full'></img></span>
                    <span className='uppercase font-semibold text-lg'>8 Years of experience</span>
                    <span className='opacity-80 font-semibold text-base w-80'>Make your business identity as unique as possible</span>
                </div>
            </div>
        </div>
        <div className='px-24 py-32 h-[48rem] w-screen overflow-hidden'>
            <div className='flex gap-12 items-center'>
                <div className='flex'>
                    <span className='w-[35rem] h-[35rem] bg-slate-900 rounded-tr-[3rem] rounded-bl-[3rem] flex relative'></span>
                </div>
                <div className='flex flex-col gap-5 mt-8'>
                    <span className='text-lg font-light tracking-wider opacity-80 w-[35rem]'>Vyda Agency isn't just a marketing agency; it's a powerhouse of creativity, PR mastery, and strategic brilliance. We don't just provide services; we equip our clients with a toolkit that empowers them to focus on what truly matters - realizing their full potential.</span>
                    <span className='text-lg font-light tracking-wider opacity-80 w-[35rem]'>Our expertise lies in delivering a comprehensive approach to both local and global clients who demand nothing short of rapid, specialized, and top-tier services. We understand the pace of modern business, and we're here to ensure you not only keep up but surge ahead.</span>
                    <span className='text-lg font-light tracking-wider opacity-80 w-[35rem]'>At Vyda Agency, we're not just about services - were about transformation. We're about revealing the latent potential within your brand, harnessing the power of creativity, publicity, and strategy to catapult you to new heights Our commitment is to enable businesses, both local and international, with the tools and expertise needed to not just survive, but to thrive.</span>
                </div>
                
            </div>
        </div>
        <Team />
    </div>
  )
}

export default AboutContent;